import React from "react";

import SendTemplateDrawer from "./SendTemplateDrawer";

/**
 * Bulk "Send Email" from the leads list. The picking, preview and sending all
 * live in SendTemplateDrawer, which posts one send per lead so each mail is
 * rendered with that lead's own details.
 */
const SendEmailDrawer = ({ open, onClose, selectedRecords = [], onSent }) => (
  <SendTemplateDrawer
    open={open}
    onClose={onClose}
    channel="EMAIL"
    leads={selectedRecords}
    onSent={onSent}
  />
);

export default SendEmailDrawer;
